module.exports = __webpack_public_path__ + "img/collection-weddingRingsRingSets@2x.608a041.webp";